import { settingsMetadata } from "./metadata";
import { generateCommunityTypeQuestions } from "./settings-generator";
export const optionalCommunityTypesForStates = (states) => settingsMetadata.filter(m => !m.autoInclude &&
    (!m.states ||
        m.states.some(s => states.includes(s.toLocaleLowerCase().trim()))));
export const optionalCommunityTypesForState = (state) => optionalCommunityTypesForStates([state]);
export const generateCommunityQuestionsForState = (request) => {
    const entries = settingsMetadata.filter(m => (!m.states ||
        m.states.some(s => s.toLocaleLowerCase().trim() === request.state)) &&
        (m.autoInclude ||
            request.includedOptionalCommunityTypes.includes(m.communityType)));
    const prefs = {
        floorplanPricing: request.floorplanPricing,
        squareFootage: request.squareFootage,
        states: [request.state],
    };
    return generateCommunityTypeQuestions(entries, prefs);
};
//# sourceMappingURL=provisioning.js.map